import React from "react";
import {
  getPredictionFillColor,
  PREDICTION_STRIPE_BACKGROUND_IMAGE,
  PREDICTION_STRIPE_PERIOD,
} from "tools/predictionStripePattern";
import { StripeOverlayRect } from "./incidentsChartStripes";

type Props = {
  overlays: StripeOverlayRect[];
};

const IncidentsChartStripeOverlay = ({ overlays }: Props) => {
  if (overlays.length === 0) {
    return null;
  }

  return (
    <div
      aria-hidden
      style={{
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
        overflow: "hidden",
      }}
    >
      {overlays.map((overlay) => {
        const offsetX = ((overlay.left % PREDICTION_STRIPE_PERIOD) + PREDICTION_STRIPE_PERIOD) % PREDICTION_STRIPE_PERIOD;
        const offsetY = ((overlay.top % PREDICTION_STRIPE_PERIOD) + PREDICTION_STRIPE_PERIOD) % PREDICTION_STRIPE_PERIOD;

        return (
          <div
            key={overlay.key}
            style={{
              position: "absolute",
              left: overlay.left,
              top: overlay.top,
              width: overlay.width,
              height: overlay.height,
              backgroundColor: getPredictionFillColor(overlay.color),
              backgroundImage: PREDICTION_STRIPE_BACKGROUND_IMAGE,
              backgroundPosition: `${-offsetX}px ${-offsetY}px`,
            }}
          />
        );
      })}
    </div>
  );
};

export default IncidentsChartStripeOverlay;
